import * as types from './constants';

export const getCommissionRulesRequest = data => (
  { type: types.GET_COMMISSION_RULES_REQUEST, payload: data }
);
export const getCommissionRulesDone = data => (
  { type: types.GET_COMMISSION_RULES_DONE, payload: data }
);
export const getCommissionRulesFailed = errors => (
  { type: types.GET_COMMISSION_RULES_FAILED, payload: errors }
);

export const createCommissionRuleRequest = data => (
  { type: types.CREATE_COMMISSION_RULE_REQUEST, payload: data }
);
export const createCommissionRuleDone = data => (
  { type: types.CREATE_COMMISSION_RULE_DONE, payload: data }
);
export const createCommissionRuleFailed = errors => (
  { type: types.CREATE_COMMISSION_RULE_FAILED, payload: errors }
);

export const updateCommissionRuleRequest = data => (
  { type: types.UPDATE_COMMISSION_RULE_REQUEST, payload: data }
);
export const updateCommissionRuleDone = data => (
  { type: types.UPDATE_COMMISSION_RULE_DONE, payload: data }
);
export const updateCommissionRuleFailed = errors => (
  { type: types.UPDATE_COMMISSION_RULE_FAILED, payload: errors }
);

export const deleteCommissionRuleRequest = data => (
  { type: types.DELETE_COMMISSION_RULE_REQUEST, payload: data }
);
export const deleteCommissionRuleDone = data => (
  { type: types.DELETE_COMMISSION_RULE_DONE, payload: data }
);
export const deleteCommissionRuleFailed = errors => (
  { type: types.DELETE_COMMISSION_RULE_FAILED, payload: errors }
);

export const reorderCommissionRuleRequest = data => (
  { type: types.REORDER_COMMISSION_RULE_REQUEST, payload: data }
);
export const reorderCommissionRuleDone = data => (
  { type: types.REORDER_COMMISSION_RULE_DONE, payload: data }
);
export const reorderCommissionRuleFailed = errors => (
  { type: types.REORDER_COMMISSION_RULE_FAILED, payload: errors }
);

export const clearCommissionRuleErrors = () => (
  { type: types.CLEAR_COMMISSION_RULE_ERRORS }
);
